
import DataHelpers from './DataHelpers'
import ArrayHelpers from './ArrayHelpers'
import Utilities from './Utilities'
import Vue from 'vue'


export default class {

    saveSelectedKeys(code, keys) {

    }

    getSelectedKeys(code, keys) {
        
    }


    //Pre Jan 19

    static select(key, selectedKeys) {
        ArrayHelpers.pushUnique(key, selectedKeys)
    }

    static unselect(key, selectedKeys) {
        ArrayHelpers.deleteItem(key, selectedKeys)
    }

    static toggleItem(item, array) {
        let idx = array.indexOf(item)
        if(idx == -1)
            array.push(item)
        else    
            array.splice(idx, 1)
    }

    static prepareSave(obj) {
        let newObj = {...obj}
        if(!newObj.key){
            newObj.key = DataHelpers.getKey()
        }
        newObj.stamp = DataHelpers.getStamp()  
        return newObj      
    }

    static save(obj, arr, position) {
        let idx = arr.findIndex(o => o.key == obj.key)
        if(idx >=0) {
            let existingObj = arr[idx]
            let newObj = Object.assign({}, existingObj, obj)
            Vue.set(arr, idx, newObj)
        } else {
            let newObj = {...obj}
            if(position === 0)
                arr.unshift(newObj)
            else
                arr.push(newObj)
        }
    }


    //to remove later?
    static saveToArray(obj, arr, position) {
        let newObj = Object.assign({}, obj)
        newObj.key = DataHelpers.getKey()
        newObj.stamp = DataHelpers.getStamp()
        if(position == 0)
            arr.unshift(newObj)
        else
            arr.push(newObj)
        return newObj
    }

    static delete(obj, arr) {
        //Utilities.log('ListHelpers > delete')
    
        let idx = arr.findIndex(o => o.key == obj.key)
        if(idx >= 0)
            arr.splice(idx, 1)
        else
            Utilities.log('ListHelpers > delete > Cant find object', obj)
    }

    static isSelected(key, selectedKeys) {
        return (selectedKeys.indexOf(key) > -1)
    }

    static selectSingle(key, selectedKeys) {
        let previouslySelected = this.isSelected(key, selectedKeys)
        let multipleSelected = selectedKeys.length > 1

        selectedKeys.splice(0, selectedKeys.length)
    
        if(!previouslySelected || multipleSelected)
            this.select(key, selectedKeys)
    }
    
    static selectMulti(key, selectedKeys) {
        this.toggleItem(key, selectedKeys)
    }

    static selectRange(key, selectedKeys, allKeys) {
        if(selectedKeys.length < 1) {
            this.select(key, selectedKeys)
            return 
        }
        let reachedSelected = false
        let reachedCurrent = false
        let shouldSelect = false
        let loopKey

        for(var n=0; n<allKeys.length; n++) {
            loopKey = allKeys[n]

            if(this.isSelected(loopKey, selectedKeys)) 
                reachedSelected = true

            if(loopKey == key)
                reachedCurrent = true

            if(reachedCurrent || reachedSelected)
                this.select(loopKey, selectedKeys)

            if(reachedCurrent && reachedSelected)
                break
        }

    }    

    static changeSelection(key, value, selectedKeys) {
        if(value == null)
            value = !Boolean(obj.selected)
        
        this.select(key, selectedKeys)    
    }

    static getSelectedItems(items, selectedKeys) {
        return items.filter(o => {
            return (selectedKeys.indexOf(o.key) > -1)
        })
    }

    static unselectAll(array) {
        this.getSelectedItems(array).forEach(item => {
            this.changeSelection(item, false)
        })
    }

    static selectedOrClicked(obj, selectedObjects) {
        let idx = selectedObjects.findIndex(o => o.key == obj.key)
        if(idx >= 0) 
            return selectedObjects
        else
            return [obj]
    }


}


// WEBPACK FOOTER //
// ./src/helpers/SelectionHelpers.js